import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  Input,
  ElementRef,
} from '@angular/core';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { GraphsService } from '@services/graphs.service';
import { RenderedService } from '../../rendered.service';

@Component({
    selector: 'scaffold-data-visuals',
    templateUrl: './data-visuals.component.html',
    styleUrls: ['./data-visuals.component.scss'],
    standalone: false
})
export class DataVisualsComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  hostElement: HTMLElement;
  displayGraph;
  constructor(
    public cdr: ChangeDetectorRef,
    public elRef: ElementRef,
    private graph: GraphsService,
    public renderedService: RenderedService
  ) {
    super(cdr, renderedService);
    this.hostElement = this.elRef.nativeElement;
  }

  ngOnInit() {
    let values: Array<any> = this.item.data_items.map(v => {
      console.log(v.value);
      return parseInt(v.value);
    });
    this.displayGraph = this.graph.generatePie(
      this.hostElement,
      values,
      this.item
    );
  }

  ngOnDestroy() {}
}
